<div class="code-icons">
  <a *ngIf="row.analogCount > 0" [routerLink]="['/catalog']" [queryParams]="{'keyword':analogTerm + ':' + row.flatCodes[environment.flatCodeAnalogAndRelated]}" i18n-nbTooltip="@@Analogs" nbTooltip="Аналоги товара">
    <nb-icon icon="copy-outline"/>
  </a>
  <a *ngIf="row.relatedCount > 0" [routerLink]="['/catalog']" [queryParams]="{'keyword':relatedTerm + ':'+row.flatCodes[environment.flatCodeAnalogAndRelated]}" i18n-nbTooltip="@@Related" nbTooltip="Сопутствующие товары">
    <nb-icon icon="layers-outline"/>
  </a>
  <a target="_blank" [routerLink]="['/product', row.sync === false ? row.syncUidPim : (row.url || row.syncUid)]" nbTooltip="Открыть в новом окне" i18n-nbTooltip="@@ProductPage">
    <nb-icon icon="external-link"/>
  </a>
</div>
